

TRANSLATIONS.en.CHARGINGINFO = {
  TITLE: 'Charging station',
  POWER: 'Power',
  EQUIPMENT: 'Equipment',
  EQUIPMENT_BASIC: 'Technical Equipment incl. charge\n' +
  'controller, Open Charge Protocol\n' +
  '(OCPP), 1.6\n\n' +
  'Electricity meter (top-hat rail meter)\n' +
  'with Modbus protocol\n\n' +
  'Type 2 charger socket with shutter\n\n' +
  'Overvoltage protection (optional)',
  EQUIPMENT_ADV: 'Technical Equipment incl. charge\n' +
  'controller, Open Charge Protocol\n' +
  '(OCPP), 1.6\n\n' +
  'Electricity meter (top-hat rail meter)\n' +
  'with Modbus protocol\n\n' +
  'Type 2 charger socket with shutter\n\n' +
  'Overvoltage protection (optional)\n\n' +
  'RFID card reader, QR code\n\n' +
  'Reservation function\n\n' +
  'Functional LED light ring\n' +
  '(charge status indicator)\n\n',
  EQUIPMENT_PROF: 'Technical Equipment incl. charge\n' +
  'controller, Open Charge Protocol\n' +
  '(OCPP), 1.6\n\n' +
  'Electricity meter (top-hat rail meter)\n' +
  'with Modbus protocol\n\n' +
  'Type 2 charger socket with shutter\n\n' +
  'Overvoltage protection (optional)\n\n' +
  'RFID card reader, QR code\n\n' +
  'Reservation function\n\n' +
  'Functional LED light ring\n' +
  '(charge status indicator)\n\n' +
  'RCD protection switch type A with\n' +
  'standardized DC residual current\n' +
  'monitoring & cable protection',
  EXLPANATION: 'RFID = Radio-Frequency Identification\n'+
  'QR code = Quick-Response Code',
  OK: 'Ok'
};

TRANSLATIONS.en.CHARGINGINFO.CHARGING_BASIC = TRANSLATIONS.en.CHARGING.CHARGING_BASIC;
TRANSLATIONS.en.CHARGINGINFO.CHARGING_ADV = TRANSLATIONS.en.CHARGING.CHARGING_ADV;
TRANSLATIONS.en.CHARGINGINFO.CHARGING_PROF = TRANSLATIONS.en.CHARGING.CHARGING_PROF;

